'use strict';

var index = (function () {
    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
    }

    var obj = {};

    var _loop = function _loop(i) {
        Object.keys(params[i]).forEach(function (key) {
            if (params[i].hasOwnProperty(key)) {
                obj[key] = params[i][key];
            }
        });
    };

    for (var i = 0; i < params.length; i++) {
        _loop(i);
    }
    return obj;
});

module.exports = index;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0ZW5kLmpzIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXguanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgKC4uLnBhcmFtcykgPT4ge1xuICAgIGxldCBvYmogPSB7fTtcbiAgICBmb3IobGV0IGkgPSAwOyBpIDwgcGFyYW1zLmxlbmd0aDsgaSsrKSB7XG4gICAgICAgIE9iamVjdC5rZXlzKHBhcmFtc1tpXSkuZm9yRWFjaCgoa2V5KSA9PiB7XG4gICAgICAgICAgICBpZihwYXJhbXNbaV0uaGFzT3duUHJvcGVydHkoa2V5KSkge1xuICAgICAgICAgICAgICAgIG9ialtrZXldID0gcGFyYW1zW2ldW2tleV07XG4gICAgICAgICAgICB9XG4gICAgICAgIH0pO1xuICAgIH1cbiAgICByZXR1cm4gb2JqO1xufTsiXSwibmFtZXMiOlsicGFyYW1zIiwib2JqIiwiaSIsImtleXMiLCJmb3JFYWNoIiwia2V5IiwiaGFzT3duUHJvcGVydHkiLCJsZW5ndGgiXSwibWFwcGluZ3MiOiI7O0FBQUEsYUFBZSxZQUFlO3NDQUFYQSxNQUFXO2NBQUE7OztRQUN0QkMsTUFBTSxFQUFWOzsrQkFDUUMsQ0FGa0I7ZUFHZkMsSUFBUCxDQUFZSCxPQUFPRSxDQUFQLENBQVosRUFBdUJFLE9BQXZCLENBQStCLFVBQUNDLEdBQUQsRUFBUztnQkFDakNMLE9BQU9FLENBQVAsRUFBVUksY0FBVixDQUF5QkQsR0FBekIsQ0FBSCxFQUFrQztvQkFDMUJBLEdBQUosSUFBV0wsT0FBT0UsQ0FBUCxFQUFVRyxHQUFWLENBQVg7O1NBRlI7OztTQURBLElBQUlILElBQUksQ0FBWixFQUFlQSxJQUFJRixPQUFPTyxNQUExQixFQUFrQ0wsR0FBbEMsRUFBdUM7Y0FBL0JBLENBQStCOztXQU9oQ0QsR0FBUDtDQVRKOzs7OyJ9



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/extend/dist/extend.js
// module id = 192
// module chunks = 4